import { Route, Redirect } from 'react-router-dom';
import React, { Suspense, lazy, Component } from 'react';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import Login from '../../Containers/Login';
import { refreshToken } from '../../reducers/AdminAuth';
import { ADMIN_TOKEN_KEY, DASHBOARD_PATH, ROUTES } from '../../config/constants';
import DashliteLayout from '../DashliteLayout';

const Dashboards = lazy(() => import('../../Containers/Dashboard'));
const Groups = lazy(() => import('../../Containers/Groups'));
const Students = lazy(() => import('../../Containers/Students'));
const Assignments = lazy(() => import('../../Containers/Assignments'));
const StudyMaterial = lazy(() => import('../../Containers/StudyMaterial'));
const Doubts = lazy(() => import('../../Containers/Doubts'));
const Streams = lazy(() => import('../../Containers/Streams'));
const Settings = lazy(() => import('../../Containers/Settings'));
const tour = lazy(() => import('../../Containers/Guides/tour'));
const guide = lazy(() => import('../../Containers/Guides/index'));
const Feedback = lazy(() => import('../../Containers/Feedback'));
const Conferences = lazy(() => import('../../Containers/Conferences'));
const Messages = lazy(() => import('../../Containers/Messages'));
const quizzes = lazy(() => import('../../Containers/Quiz'));
const reports = lazy(() => import('../../Containers/Reports'));
const updateLogo = lazy(() => import('../../Containers/UpdateLogo'));

const Loader = ({ size = 'lg' }) => (
  <div className="loader-container text-center py-5">
    <Spinner size={size} color="primary" />
  </div>
);

class AppMain extends Component {
  componentDidMount() {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (token && !this.props.AdminAuth.loggedIn) {
      this.props.refreshToken();
    }
  }

  render() {
    if (!this.props.AdminAuth.loggedIn) {
      return <Login />;
    }

    return (
      <DashliteLayout>
        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.DASHBOARD} component={Dashboards} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.STUDENTS} component={Students} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.GROUPS} component={Groups} />
          <Route path="/chapters" render={({ location }) => (
            <Redirect to={`${location.pathname.replace(/^\/chapters/, ROUTES.GROUPS)}${location.search}`} />
          )} />
          <Route path="/iaept-members" render={({ location }) => (
            <Redirect to={`${location.pathname.replace(/^\/iaept-members/, ROUTES.STUDENTS)}${location.search}`} />
          )} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.ASSIGNMENTS} component={Assignments} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.STUDY_MATERIAL} component={StudyMaterial} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.DOUBTS} component={Doubts} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.STREAMS} component={Streams} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.QUIZ} component={quizzes} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.UPDATE_LOGO} component={updateLogo} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.REPORTS} component={reports} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.SETTINGS} component={Settings} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.TOUR} component={tour} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path="/guide/:id" component={guide} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.FEEDBACK} component={Feedback} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.CONFERENCES} component={Conferences} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.MESSAGES} component={Messages} />
        </Suspense>

        <Route exact path="/" render={() => (
          <Redirect to={DASHBOARD_PATH} />
        )} />
      </DashliteLayout>
    );
  }
}

const mapStateToProp = state => ({
  AdminAuth: state.AdminAuth,
});

const mapDispatchToProps = dispatch => ({
  refreshToken: () => refreshToken(dispatch),
});

export default connect(mapStateToProp, mapDispatchToProps)(AppMain);
